class UserRole {
    constructor(text) {
        this.text = text;
    }
}

export const USER_ROLES = {
    SUPERADMIN: new UserRole("SUPERADMIN"),
    ADMINISTRATOR : new UserRole("ADMINISTRATOR"),
};